import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/nodata.svg'


const _hoisted_1 = { class: "global_search_div" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#aaa","margin-right":"25px"} }, "搜索全站", -1)
const _hoisted_3 = {
  key: 0,
  class: "global_search_history padding_l_r_24"
}
const _hoisted_4 = { class: "global_search_history_title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#aaa"} }, "搜索历史", -1)
const _hoisted_6 = { class: "global_search_history_content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "global_search_content_wrapper padding_l_r_24" }
const _hoisted_9 = {
  key: 0,
  class: "global_search_content_tabs"
}
const _hoisted_10 = { class: "global_search_content" }
const _hoisted_11 = {
  key: 0,
  class: "item_title"
}
const _hoisted_12 = { class: "category" }
const _hoisted_13 = {
  key: 0,
  class: "no_data_wrapper"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_15 = { class: "font_14_color_54_weight_500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        shape: "round",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.globalSearchVisible = true)),
        type: "ghost",
        class: "gloabl_search_btn"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_svg_icon, {
            "icon-name": "SearchOutlined",
            style: {"color":"#aaa"}
          })
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.globalSearchVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.globalSearchVisible) = $event)),
      style: {"top":"64px"},
      footer: null,
      afterClose: _ctx.afterClose,
      class: "global_search_modal_wrapper",
      width: "800px",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "global_search_header padding_l_r_24" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { class: "global_search_header_icon middle_div" }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-name": "SearchOutlined" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { class: "global_search_header_input" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "查找：菜单、客户、合同、账单等",
                  value: _ctx.searchContent,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchContent) = $event)),
                  ref: "seach_input",
                  onChange: _ctx.doSearch
                }, null, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              class: "global_search_header_icon middle_div",
              style: {"justify-content":"flex-end"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  "icon-name": "CloseOutlined",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.globalSearchVisible = false))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.filter_resulet.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                ((_ctx.global_search_items_self || []).length !== 0)
                  ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 0,
                      "icon-name": "DeleteOutlined",
                      onClick: _ctx.deleteHistory
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.global_search_items_self, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "global_search_history_item",
                    key: index,
                    onClick: ($event: any) => (_ctx.searchByHistory(item))
                  }, _toDisplayString(item), 9, _hoisted_7))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.entity_map.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_a_tabs, {
                  activeKey: _ctx.activeKey,
                  "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeKey) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entity_map, (item) => {
                      return (_openBlock(), _createBlock(_component_a_tab_pane, {
                        key: item.entity,
                        tab: item.title
                      }, null, 8, ["tab"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter_resulet, (block, bi) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "search_result_block",
                key: bi
              }, [
                (_ctx.filter_resulet.length !== 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(block.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.data_list, (x, i) => {
                  return (_openBlock(), _createBlock(_component_a_button, {
                    class: "searched_item",
                    style: {"display":"block"},
                    type: "link",
                    key: i,
                    onClick: ($event: any) => (_ctx.jumpTo(block.entity, x.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(x.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ], 512)), [
                [_vShow, block.data_list.length]
              ])
            }), 128)),
            (_ctx.entity_map.length === 0 && !_ctx.searching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.tipContent), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_spin, {
              spinning: _ctx.searching,
              tip: "正在搜索中......"
            }, null, 8, ["spinning"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "afterClose"])
  ], 64))
}